import React, { useState, useEffect } from 'react';
import contentService from '../services/contentService';
import './ReporteGeves.css';
import Loading from '../components/Loading';

const ROLE_COLOR = { marca: '#71d234', competencia: '#f59e0b', referencia: '#6366f1' };
const ROLE_LABEL = { marca: 'Mi Marca', competencia: 'Competencia', referencia: 'Referencia' };
const DIM_LABELS = [
  { key: 'engagement_score',  label: 'ER',          weight: '35%', raw: 'engagement_rate', fmt: v => `${v}%` },
  { key: 'growth_score',      label: 'Crecimiento', weight: '20%', raw: 'growth_pct',       fmt: v => `${v > 0 ? '+' : ''}${v}%` },
  { key: 'consistency_score', label: 'Consistencia',weight: '15%', raw: 'posts_period',     fmt: v => `${v} posts` },
  { key: 'reach_score',       label: 'Alcance',     weight: '15%', raw: null,               fmt: null },
  { key: 'reel_score',        label: 'Reels',       weight: '10%', raw: 'reel_ratio_pct',   fmt: v => `${v}%` },
  { key: 'virality_score',    label: 'Viralidad',   weight: '5%',  raw: null,               fmt: null },
];

function ScoreBar({ value }) {
  const color = value >= 70 ? '#71d234' : value >= 40 ? '#f59e0b' : '#ef4444';
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <div style={{ flex: 1, height: 6, background: 'rgba(0,36,33,0.08)', borderRadius: 3, overflow: 'hidden' }}>
        <div style={{ width: `${value}%`, height: '100%', background: color, borderRadius: 3, transition: 'width 0.4s' }} />
      </div>
      <span style={{ fontSize: 13, fontWeight: 700, color: '#002421', minWidth: 34, textAlign: 'right' }}>{value}</span>
    </div>
  );
}

function RankingTable({ roles = null, title }) {
  const [data,   setData]   = useState(null);
  const [loading,setLoading]= useState(true);
  const [expand, setExpand] = useState(null);
  const [days,   setDays]   = useState(30);

  useEffect(() => {
    setLoading(true);
    contentService.getMercadoRanking(days)
      .then(r => setData(r.data))
      .finally(() => setLoading(false));
  }, [days]);

  if (loading) return <Loading fullScreen={false} mensaje="Calculando ranking" />;

  const ranking = (data?.ranking || [])
    .filter(r => !roles || roles.includes(r.role))
    .map((r, i) => ({ ...r, rank: i + 1 }));

  if (!ranking.length) return <div className="rg2-empty">Sin perfiles en esta sección todavía.</div>;

  return (
    <div className="rg2-chart-card" style={{ marginBottom: 28 }}>
      <div className="rg2-chart-header">
        <span className="rg2-chart-title">{title}</span>
        <div className="rg2-chart-tabs">
          {[30, 60, 90].map(d => (
            <button key={d} className={`rg2-chart-tab${days === d ? ' active' : ''}`} onClick={() => setDays(d)}>
              {d}d
            </button>
          ))}
        </div>
      </div>

      {/* Leyenda criterios */}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px 14px', marginBottom: 16 }}>
        {DIM_LABELS.map(d => (
          <span key={d.key} style={{ fontSize: 11, color: '#4a5854' }}>
            <b style={{ color: '#002421' }}>{d.label}</b> {d.weight}
          </span>
        ))}
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {ranking.map(r => (
          <div key={r.id} style={{
            border: '1px solid rgba(0,36,33,0.08)', borderRadius: 12,
            background: '#fff', overflow: 'hidden',
          }}>
            <div
              style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px', cursor: 'pointer' }}
              onClick={() => setExpand(expand === r.id ? null : r.id)}
            >
              {/* Posición */}
              <div style={{
                width: 28, height: 28, borderRadius: '50%', flexShrink: 0,
                background: r.rank === 1 ? '#002421' : r.rank === 2 ? '#4a5854' : '#e5e7eb',
                color: r.rank <= 2 ? '#fff' : '#374151',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 12, fontWeight: 800,
              }}>#{r.rank}</div>

              {/* Avatar inicial */}
              <div style={{
                width: 36, height: 36, borderRadius: '50%', flexShrink: 0,
                background: ROLE_COLOR[r.role] + '22',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 13, fontWeight: 700, color: ROLE_COLOR[r.role],
              }}>
                {r.username[0].toUpperCase()}
              </div>

              {/* Info */}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 2, flexWrap: 'wrap' }}>
                  <span style={{ fontWeight: 700, fontSize: 13, color: '#002421' }}>@{r.username}</span>
                  <span style={{
                    fontSize: 10, fontWeight: 700, padding: '1px 6px', borderRadius: 4,
                    background: ROLE_COLOR[r.role] + '20', color: ROLE_COLOR[r.role],
                  }}>{ROLE_LABEL[r.role]}</span>
                </div>
                <div style={{ fontSize: 11, color: '#4a5854' }}>
                  {r.ai_category && <span>{r.ai_category} · </span>}
                  {(r.followers_count || 0).toLocaleString()} seg.
                </div>
              </div>

              {/* Score bar */}
              <div style={{ width: 160, flexShrink: 0 }}>
                <ScoreBar value={r.score} />
              </div>

              <span style={{ fontSize: 11, color: '#94a3b8', flexShrink: 0 }}>
                {expand === r.id ? '▲' : '▼'}
              </span>
            </div>

            {/* Desglose */}
            {expand === r.id && (
              <div style={{
                borderTop: '1px solid rgba(0,36,33,0.06)',
                padding: '14px 16px',
                background: '#fbfaf7',
                display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '12px 20px',
              }}>
                {DIM_LABELS.map(dim => (
                  <div key={dim.key}>
                    <div style={{ fontSize: 10, color: '#4a5854', fontWeight: 700, textTransform: 'uppercase', marginBottom: 3 }}>
                      {dim.label} <span style={{ color: '#00694f' }}>{dim.weight}</span>
                    </div>
                    <ScoreBar value={r.breakdown[dim.key]} />
                    {dim.raw && r.breakdown[dim.raw] != null && (
                      <div style={{ fontSize: 10, color: '#4a5854', marginTop: 2 }}>
                        {dim.fmt(r.breakdown[dim.raw])}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default function RankingPage() {
  return (
    <div className="rg2-page">
      <div className="rg2-header" style={{ marginBottom: 28 }}>
        <div>
          <h1 className="rg2-title">Ranking</h1>
          <p style={{ margin: 0, fontSize: 13, color: '#4a5854', marginTop: 4 }}>
            Score 0–100 basado en engagement, crecimiento, consistencia, alcance, reels y viralidad.
          </p>
        </div>
      </div>

      <RankingTable
        roles={['marca', 'competencia']}
        title="Competencia vs Mi Marca"
      />

      <RankingTable
        roles={['referencia']}
        title="Referencia"
      />
    </div>
  );
}
